module.exports = __webpack_public_path__ + "img/13.bf4c91d5.png";